import { HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  BulkDeleteCrmObjectsRequestInterface,
  CreateCrmObjectRequestInterface,
  CreateCrmObjectResponseInterface,
  DeleteCrmObjectRequestInterface,
  DismissPotentialContactRequestInterface,
  GetMultiCrmObjectRequestInterface,
  GetMultiCrmObjectResponseInterface,
  ListCrmObjectsRequestInterface,
  ListCrmObjectsResponseInterface,
  ListFieldOptionsRequestInterface,
  ListFiltersRequestInterface,
  ListFiltersResponseInterface,
  PotentialContactsApiService,
  PromoteToContactRequestInterface,
  PromoteToContactResponseInterface,
  UpdateCrmObjectRequestInterface,
  ValidateCrmObjectRequestInterface,
  ValidateCrmObjectResponseInterface,
} from '@vendasta/crm';
import { Observable, of } from 'rxjs';
import { AbstractCrmObjectService } from './_abstract.service';
import { ContactService } from './_contact.service';

// PotentialContact has no UI for create / edit / validate today (the only flows are
// list, promote, and dismiss). The create / update / validate methods are kept here
// because AbstractCrmObjectService requires them; if a future feature wires them up,
// note that validate currently delegates to ContactService and will fail to recognize
// PotentialContact's `-potential-contact`-suffixed field IDs without further work.
@Injectable({ providedIn: 'root' })
export class PotentialContactService implements AbstractCrmObjectService {
  private readonly service = inject(PotentialContactsApiService);
  private readonly contactService = inject(ContactService);

  createCrmObject(request: CreateCrmObjectRequestInterface): Observable<CreateCrmObjectResponseInterface> {
    return this.service.createPotentialContact(request);
  }

  deleteCrmObject(request: DeleteCrmObjectRequestInterface): Observable<HttpResponse<null>> {
    return this.dismiss({ namespace: request.namespace, potentialContactId: request.crmObjectId });
  }

  validateCrmObject(_: ValidateCrmObjectRequestInterface): Observable<ValidateCrmObjectResponseInterface> {
    return this.contactService.validateCrmObject(_);
  }

  updateCrmObject(request: UpdateCrmObjectRequestInterface): Observable<HttpResponse<null>> {
    return this.service.updatePotentialContact(request);
  }

  listObjects(request: ListCrmObjectsRequestInterface): Observable<ListCrmObjectsResponseInterface> {
    return this.service.listPotentialContacts(request);
  }

  listObjectsFilters(request: ListFiltersRequestInterface): Observable<ListFiltersResponseInterface> {
    return this.contactService.listObjectsFilters(request);
  }

  getMultiObject(request: GetMultiCrmObjectRequestInterface): Observable<GetMultiCrmObjectResponseInterface> {
    return this.service.getMultiPotentialContact(request);
  }

  listFieldOptions(request: ListFieldOptionsRequestInterface): Observable<string[]> {
    return this.contactService.listFieldOptions(request);
  }

  bulkDelete(_: BulkDeleteCrmObjectsRequestInterface): Observable<HttpResponse<null>> {
    return of(new HttpResponse<null>({ status: 501, statusText: 'Not Implemented' }));
  }

  promote(request: PromoteToContactRequestInterface): Observable<PromoteToContactResponseInterface> {
    return this.service.promoteToContact(request);
  }

  dismiss(request: DismissPotentialContactRequestInterface): Observable<HttpResponse<null>> {
    return this.service.dismissPotentialContact(request);
  }
}
